import * as XLSX from 'xlsx';
import { setCellStyleByClassname, setRowStyle, generateFillColorStyle, setSheetStyle } from '../excel/excel_style';

export function formatDefaultExport(sheetData: XLSX.WorkSheet) {
    const font8norm = { font: { sz: '8', bold: false, name: 'Arial', color: { rgb: 'FF000000' } } };
    const borderBotMedium = { border: { bottom: { style: 'medium' } } };
    const darkBg = generateFillColorStyle('FFDDDDDD');
    const alignment = { alignment: { wrapText: true, vertical: 'top', horizontal: 'left' } };
    setSheetStyle(sheetData, font8norm);
    // setRowStyle(sheetData, { ...borderBotMedium, ...font8norm, ...darkBg, ...alignment }, 0);
    setCellStyleByClassname(sheetData, { ...borderBotMedium, ...font8norm, ...darkBg, ...alignment }, 'header');
}
